import { Injectable } from '@angular/core';
import {
    AccessRightFilterCollectionModel,
    ICommentModel,
    ILightWeightUser,
    ISiteDesignAccessItem,
} from '@fi-shared/models';
import { ObjectTypes } from '@fi-shared/types/object-type';
import { FiDateTimeFormatOptions } from '@fi-shared/utils/format-date';
import { FiCommentSettingType, PersonalNotificationsCategoryType } from '@fi-shared/types';
import { IMediaBankFileReference } from '@fi-shared/media-bank';
import { IPostReadsData } from '@fi-shared/fi-news-feed-shared/fi-news-feed-buttons/fi-reads-count-button/fi-reads-data';
import { IUserProfile } from '@fi-shared/profile-icon/profile-icon.component';
import { INotificationCategoryItem } from '@fi-shared/fi-notification/fi-notification';
import {
    INewsFeedContent,
    INewsFeedGroupedItem,
    INewsFeedModel,
} from '@fi-shared/fi-news-feed-shared/fi-news-feed-shared';
import { IReactionModel } from '@fi-shared/fi-likes/fi-likes';
import { FiFormatDateService } from '@fi-shared/fi-format-date/fi-format-date.service';
import { ICreatedByItem } from '@fi-shared/models/models';

export class NewsFeedModel implements INotificationCategoryItem, ISiteDesignAccessItem {
    Id = 0;
    ObjectId = 0;
    ObjectType = ObjectTypes.Post;
    Content: INewsFeedContent = {};
    ChangedOn = new Date();
    CreatedOn = new Date();
    ChangedOnDateTime = '';
    CreatedByUserId = 0;
    CreatedByUserName = '';
    UserProfile: IUserProfile;
    Links = [];
    MediaBankFileReferences: IMediaBankFileReference[] = [];
    CommentSettingType: FiCommentSettingType = FiCommentSettingType.AllowAllComments;
    ShowComments = true;
    ShowMore = true;
    ReadsData: IPostReadsData[] = [];
    ForumId: number = null;
    ForumName: string = null;
    HasEditAccess: boolean = null;
    HasDeleteAccess: boolean = null;

    InitialComments: ICommentModel[];

    ShowCommentsCreatedBy: boolean;
    CommentsCreatedBy: ICreatedByItem[];

    ShowReactions: boolean;
    Reactions: IReactionModel[] = [];

    GroupedItems: INewsFeedGroupedItem[] = [];
    PinnedDate: string | Date; //ISO 8601 Date
    PinnedUntil: string | Date; //ISO 8601 Date
    NotificationCategory: PersonalNotificationsCategoryType = PersonalNotificationsCategoryType.Visited;
    SiteDesignIds: number[] = [];

    TaggedUsers: ILightWeightUser[] = [];

    AccessRightFilterCollection: AccessRightFilterCollectionModel;

    constructor(newsfeed: INewsFeedModel, preferredContentLanguage: number, fiFormatDateService: FiFormatDateService) {
        this.ChangedOnDateTime = fiFormatDateService.formatDate(this.ChangedOn, FiDateTimeFormatOptions);

        if (newsfeed) this.Initialize(newsfeed, preferredContentLanguage, fiFormatDateService);
    }

    Initialize(newsfeed: INewsFeedModel, preferredContentLanguage: number, fiFormatDateService: FiFormatDateService) {
        this.Id = newsfeed.Id;
        this.ObjectId = newsfeed.ObjectId;
        this.ObjectType = newsfeed.ObjectType;
        this.Content = newsfeed.Content as INewsFeedContent;
        this.ChangedOn = new Date(newsfeed.ChangedOn);
        this.ChangedOnDateTime = fiFormatDateService.formatDate(this.ChangedOn, FiDateTimeFormatOptions);
        this.CreatedOn = new Date(newsfeed.CreatedOn);
        this.CreatedByUserId = newsfeed.CreatedByUserId;
        this.CreatedByUserName = newsfeed.CreatedByUserName;
        this.UserProfile = newsfeed.UserProfile;
        this.Links = newsfeed.Links;
        this.MediaBankFileReferences = newsfeed.MediaBankFileReferences;
        this.GroupedItems = newsfeed.GroupedItems;
        this.CommentSettingType = newsfeed.CommentSettingType;
        this.ShowComments = true;
        this.ShowMore = true;
        this.NotificationCategory = newsfeed.NotificationCategory;
        this.ReadsData = newsfeed.ReadsData;
        this.ForumId = newsfeed.ForumId;
        this.ForumName = newsfeed.ForumName;

        this.InitialComments = newsfeed.InitialComments;
        this.ShowCommentsCreatedBy = newsfeed.ShowCommentsCreatedBy;
        this.CommentsCreatedBy = newsfeed.CommentsCreatedBy;

        this.Reactions = newsfeed.Reactions;
        this.ShowReactions = newsfeed.ShowReactions;

        this.PinnedDate = newsfeed.PinnedDate;
        this.PinnedUntil = newsfeed.PinnedUntil;
        this.HasEditAccess = newsfeed.HasEditAccess;
        this.HasDeleteAccess = newsfeed.HasDeleteAccess;
        this.SiteDesignIds = newsfeed.SiteDesignIds;
        this.TaggedUsers = newsfeed.TaggedUsers;
    }
}

@Injectable() // todo remove class after migration to ng4
export class NewsFeedDummy {}
